import { useHorizontalScrollFade } from 'hooks';
import { useRef } from 'react';
import { Field } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';
import styled from 'styled-components';
import { ImageComponent } from 'pages/ListerVehicleUploadV2/CameraView/components/imageList';
import { useImageListScroll } from 'pages/ListerVehicleUploadV2/CameraView/hooks/useImageListScroll';

const Container = styled.div<{ showAfterFade: boolean; showBeforeFade: boolean }>`
  margin: 0;
  padding: 0;
  overflow: hidden;
  overflow-x: auto;
  width: 100%;
  display: flex;
  gap: 6px;

  @media (orientation: landscape) {
    justify-content: center;
  }

  &:before {
    content: '';
    display: ${props => (props.showBeforeFade ? 'block' : 'none')};
    top: 0;
    left: 0;
    width: 100px;
    position: absolute;
    z-index: 999;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(90deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%);
  }

  &:after {
    content: '';
    display: ${props => (props.showAfterFade ? 'block' : 'none')};
    right: 0;
    top: 0;
    width: 100px;
    position: absolute;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TiresImageCarousel = () => {
  const { fields } = useFieldArray(`exterior.subsections.tires.images`);

  const ref = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<HTMLDivElement[]>([]);

  useImageListScroll(ref, itemRefs);

  const { showBeforeFade, showAfterFade } = useHorizontalScrollFade(ref, {
    beforeFadeThreshold: 50
  });

  return (
    <Container ref={ref} showBeforeFade={showBeforeFade} showAfterFade={showAfterFade}>
      {fields.map((field, i) => (
        <Field name={field}>
          {fieldProps => <ImageComponent setRef={el => (itemRefs.current[i] = el)} index={i} {...fieldProps.input} />}
        </Field>
      ))}
    </Container>
  );
};
